import React, { ReactElement } from 'react';

import CheckBox from '@splunk/react-icons/CheckBox';

import { EventAnnotationIconProps } from '../EventAnnotations';

export const CustomEventIcon = (props: EventAnnotationIconProps): ReactElement => (
    <CheckBox
        width={`${props.dimensions.width}px`}
        height={`${props.dimensions.width}px`}
        viewBox="0 0 24 24"
        style={{ color: props.theme.annotationIcon.customEventIconColor }}
        variant={`${props.isCleared ? 'outlined' : 'filled'}`}
    />
);
